import {
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_FAIL
} from "../types";

const initialState = {
  loading: false,
  error: null,
  // If the dashboard had its own statistics objects from a unified API:
  stats: {
    totalCustomer: 0,
    totalPackage: 0,
    totalPackageTransaction: 0,
    totalAdmin: 0,
    totalCountry: 0,
    totalState: 0,
    totalCity: 0,
    totalBusinessType: 0,
    totalGlGroup: 0,
  },
  recentCustomers: [],
  recentTransactions: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_DASHBOARD_DATA:
      return {
        state: payload?.summary,
        recentCustomers: payload?.recentCustomers,
        recentTransactions: payload?.recentTransactions,
        loading: false,
        error: null
      };

    case GET_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        stats: { ...state.stats, ...payload } // Update statistics if provided
      };

    case GET_DASHBOARD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    default:
      return state;
  }
};

export default reducer;
